const cookies = {
  acceptCookies: false,
  preferencias: false,
  analisis: false,
  publicidad: false,
};

const mutations = {
  recoverCookies (state) {
    const confCookies = JSON.parse(localStorage.getItem('confCookies'));
    if (!confCookies) {
      state.acceptCookies = false;
      state.preferencias = false;
      state.analisis = false;
      state.publicidad = false;
    } else {
      state.acceptCookies = confCookies.acceptCookies;
      state.preferencias = confCookies.preferencias;
      state.analisis = confCookies.analisis;
      state.publicidad = confCookies.publicidad;
    }
  },
  setCookiePreferencias (state, data) {
    state.preferencias = data;
  },
  setCookieAnalisis (state, data) {
    state.analisis = data;
  },
  setCookiePublicidad (state, data) {
    state.publicidad = data;
  },
  setCookies (state, data) {
    state.acceptCookies = data.accept;
    state.preferencias = data.preferencias;
    state.analisis = data.analisis;
    state.publicidad = data.publicidad;
    // eslint-disable-next-line sonarjs/prefer-object-literal
    const confCookies = {};
    confCookies.acceptCookies = data.accept;
    confCookies.preferencias = data.preferencias;
    confCookies.analisis = data.analisis;
    confCookies.publicidad = data.publicidad;
    localStorage.setItem('confCookies', JSON.stringify(confCookies));
  },
};

const actions = {};

const getters = {
  getAcceptCookies: state => state.acceptCookies,
  getCookiePreferencias: state => state.preferencias,
  getCookieAnalisis: state => state.analisis,
  getCookiePublicidad: state => state.publicidad,
};

export default {
  state: cookies,
  mutations,
  actions,
  getters,
};
